import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import './Lessons.css';

const TOPIC_ICONS = {
  hardware:   { icon: '▣', color: '#4f6ef7' },
  os:         { icon: '◎', color: '#8b5cf6' },
  networking: { icon: '◈', color: '#0ea5e9' },
  security:   { icon: '◆', color: '#10b981' },
  software:   { icon: '▤', color: '#f59e0b' },
};

export default function Lessons({ navigate }) {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const { completedTopics, quizHistory } = useGame();

  useEffect(() => {
    fetch('/api/topics')
      .then(r => r.json())
      .then(data => { setTopics(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state">Loading topics...</div>;

  return (
    <div>
      <div className="section-header">
        <div>
          <h1 className="section-title" style={{ fontSize: '1.8rem' }}>Learning Tracks</h1>
          <p className="section-subtitle">{completedTopics.length}/5 topics completed — keep going!</p>
        </div>
      </div>

      <div className="topics-grid">
        {topics.map((topic, idx) => {
          const meta = TOPIC_ICONS[topic.id] || {};
          const done = completedTopics.includes(topic.id);
          const locked = idx > 0 && !completedTopics.includes(topics[idx - 1]?.id) && !done;
          const quizzes = quizHistory.filter(h => h.topicId === topic.id);
          const best = quizzes.length > 0 ? Math.max(...quizzes.map(h => h.percentage)) : 0;

          return (
            <div
              key={topic.id}
              className={`topic-card card card-clickable ${done ? 'done' : ''} ${locked ? 'locked' : ''}`}
              onClick={() => !locked && navigate('lesson-detail', topic)}
              style={{ '--topic-color': meta.color }}
            >
              {done && <div className="topic-done-badge">&#10003; Complete</div>}
              {locked && <div className="topic-locked-badge">&#128274; Locked</div>}

              <div className="topic-icon-wrap" style={{ background: `${meta.color}18`, color: meta.color }}>
                {meta.icon}
              </div>

              <div className="topic-card-body">
                <div className="topic-difficulty">
                  <span className={`badge-difficulty ${topic.difficulty.toLowerCase()}`}>
                    {topic.difficulty}
                  </span>
                  <span className="topic-xp">+{topic.xp_reward} XP</span>
                </div>
                <h2 className="topic-name">{topic.title}</h2>
                <p className="topic-desc">{topic.description}</p>
              </div>

              {quizzes.length > 0 && (
                <div className="topic-card-footer">
                  <div className="tp-bar-outer">
                    <div className="tp-bar-inner" style={{ width: `${best}%`, background: meta.color }} />
                  </div>
                  <span className="topic-best">Best: {Math.round(best)}%</span>
                </div>
              )}

              {!locked && (
                <div className="topic-card-actions">
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={e => { e.stopPropagation(); navigate('lesson-detail', topic); }}
                  >
                    Study
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={e => { e.stopPropagation(); navigate('quiz', topic); }}
                  >
                    Quiz
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
